import React from 'react';
import { Text } from '../../foundations';
import clsx from 'clsx';
import styles from './FormErrorMessage.module.css';

export type FormErrorMessageProps = {
	/**
	 * Indicates the identifier
	 */
	id?: string;
	/**
	 * Optional CSS class name for styling the container.
	 */
	className?: string;
	/**
	 * The content or children to be displayed
	 */
	children: React.ReactNode;
};

export function FormErrorMessage({ children, className, ...props }: FormErrorMessageProps) {
	return (
		<Text as="span" font="verdana" size="md-regular" role="alert" className={clsx(styles.alert, className)} {...props}>
			{children}
		</Text>
	);
}
